import { directiveHooks } from "@vueuse/core";
import { useSplitText } from "./composable.mjs";
export const vSplitText = {
  [directiveHooks.mounted]: (el, binding) => {
    const { value } = binding;
    useSplitText(el, value);
  }
};
